import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable } from 'react-bootstrap-table';
import LoadMask from "../LoadMask/LoadMask";


export default class Grid extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: false
    };


    render() {
        const {
            loading,
            data,
            page,
            size_page=10,
            remote=true,
            expandableRow,
            expandComponent,
            cellEditProp,
            afterSave,
            onPageChange,
            onSortChange,
            pagination,
            expanding,
            onExpand,
            trClassName,
            selectRowProp,
            ...other
        } = this.props;
        const options = {
            sizePerPage: size_page,
            hideSizePerPage: true,
            paginationSize: 5,
            alwaysShowAllBtns: true,
            noDataText: loading ? 'Cargando...' : 'No hay datos',
            page,
            onPageChange: onPageChange ? onPageChange : () => {},
            onSortChange: onSortChange ? onSortChange : () => {},
            onExpand:onExpand,
            expanded: [1]
        };

        const paginar = !(pagination === false);

        // console.log('Data: ', data)

        return (
            <div>
                <LoadMask loading={loading} dark blur>
                    <BootstrapTable
                      selectRow={selectRowProp}
                        expandableRow={expandableRow}
                        expandComponent={expandComponent}
                        trClassName={trClassName}
                        cellEdit={cellEditProp}
                        data={loading ? [] : data.results}
                        afterSaveCell={afterSave}
                        remote={remote}
                        pagination={paginar}
                        expanded={[1]}
                        fetchInfo={{ dataTotalSize: data.count }}
                        options={options}
                        {...other}
                        // exportCSV
                        // csvFileName='table-export'
                    />
                </LoadMask>
            </div>

        )
    }
}
